module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_callme", [["div",{"class":"site-page call-me no-pb"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block simple"},[["div",{"class":"page-width z6"},[["div",{"class":"title","data-fox-alias":"callmeTitle","data-fox-context":"callme"},[["div",{},[["textNode",{"text":"Call me"}]]]]]]]]],["div",{"class":"verifiedcall-wrapper"},[["div",{"class":"page-width"},[["div",{"class":"verifiedcall-widget"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/callme.tpl
// module id = 1079
// module chunks = 4